// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useEffect } from 'react';
import { ControlLabel } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import ActivityAvailableWeekDays from './ActivityAvailableWeekDays';
import ActivityFormFieldWrapper from '../../ActivityForm/ActivityFormFieldWrapper';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import RadioButtons from '../../../utils/FormWidgets/RadioButtons';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import ActivityAvailableCalendar from './ActivityAvailableCalendar';
import { getAvailabilityType } from '../../../../infrastructure/utils/activities';

const WEEK_DAYS = 'WEEK_DAYS';
const CALENDAR = 'CALENDAR';

const StyledRadioButtons = styled.div`
  margin-bottom: 20px;
`;

const ActivityAvailableDays = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  label,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  value,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onMetaFieldsChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  initialValue,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  display,
}) => {
  const initialType = getAvailabilityType(value);
  const [type, setType] = useState(getAvailabilityType(value));

  useEffect(() => {
    if (type === initialType) {
      onMetaFieldsChange([{ name: 'hours', value: initialValue }]);
    } else {
      onMetaFieldsChange([{ name: 'hours', value: '' }]);
    }
  }, [type]);

  return (
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    <ActivityFormFieldWrapper label={label} display={display}>
      <ControlLabel>{label}:</ControlLabel>
      <div style={{ flex: 1 }}>
        <StyledRadioButtons>
          <RadioButtons
            name='type'
            value={type}
            label={label}
            onRadioChange={(_, val) => setType(val)}
            options={[
              { label: 'Available Days', value: WEEK_DAYS },
              { label: 'Full Availability Calendar', value: CALENDAR },
            ]}
          />
        </StyledRadioButtons>
        {type === WEEK_DAYS ? (
          <ActivityAvailableWeekDays
            label={label}
            value={value}
            onMetaFieldsChange={onMetaFieldsChange}
            initialValue={initialValue}
          />
        ) : (
          <ActivityAvailableCalendar
            value={value}
            onMetaFieldsChange={onMetaFieldsChange}
          />
        )}
      </div>
    </ActivityFormFieldWrapper>
  );
};

export default ActivityAvailableDays;
